import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { ILensInfo } from '~src/lens/models/ILensInfo';
import { Lenses } from '~src/lens/resources/Lenses';

export type projectToLensMapType = {
  [key: string]: string[];
}
export function GetLensNamesList(): Q.Promise<projectToLensMapType> {
  const blockSize = 1000;
  const deferred = Q.defer<projectToLensMapType>();
  let allItems: string[] = [];
  let projectToLensMap: projectToLensMapType = {};

  const listAllLenses = (start: number): void => {
    Lenses.all().getSlice(start, blockSize)
      .then((result: ListResult<ILensInfo>) => {
        result.items.forEach(lens => {
          if (!projectToLensMap[lens.project.id]) {
            projectToLensMap[lens.project.id] = [];
          }
          projectToLensMap[lens.project.id].push(lens.name);
        });
        allItems = allItems.concat(result.items.map(lensInfo => {
          return lensInfo.name;
        }));

        if (allItems.length < result.total) {
          listAllLenses(start + blockSize);
        } else {
          deferred.resolve(projectToLensMap);
        }
      });
  };
  listAllLenses(0);
  return deferred.promise;
}

